/**
 * Action queue for SmartResponse.
 *
 * Queues processActions() calls made before Smart.init() completes.
 * Once init is done, the queue flushes and subsequent calls execute immediately.
 */

let ready = false;
let queue = [];
let processor = null;

/**
 * Set the action processor function (Smart.utils.processActions).
 */
export function setProcessor(fn) {
    processor = fn;
}

/**
 * Mark the system as ready and flush any queued actions.
 */
export function markReady() {
    ready = true;
    flush();
}

/**
 * Process actions — queues if not ready, executes immediately if ready.
 */
export function processActions(actions) {
    if (!actions || !actions.length) return;

    if (ready && processor) {
        processor(actions);
    } else {
        queue.push(actions);
    }
}

/**
 * Flush all queued action batches.
 */
function flush() {
    if (!processor) return;

    while (queue.length > 0) {
        const actions = queue.shift();
        processor(actions);
    }
}

export default { setProcessor, markReady, processActions };
